import { useState, useEffect, useContext } from "react";
import { MultiSelect } from "../../../../components/menu/multiSelect";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useAuthFetch } from "../../../../hooks/useAuthFetch";

function SchedulingSiteFilter({
  selected,
  onUpdate,
  onClear,
  customerIds,
  setSitesOptions,
  fullWidth = false,
  labelPosition = "inset",
}) {
  const [sitesOptions, setSitesOptionsLocal] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { authContext } = useContext(AuthContext);
  const orgId = authContext.organization.orgId;
  const authFetch = useAuthFetch();

  const fetchSites = async () => {
    if (!customerIds || !orgId) return;

    try {
      const response = await authFetch(
        `${process.env.REACT_APP_API_URL}/v1/sites?org_id=${orgId}&customer_ids=${customerIds}`
      );
      if (response.ok) {
        const data = await response.json();

        const augmentedData = data.map((site) => ({
          ...site,
          name: site.site_name,
        }));

        setSitesOptionsLocal(augmentedData);
        setSitesOptions(augmentedData);
        setIsLoading(false);
      } else {
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchSites();
  }, [orgId, customerIds]);

  return (
    <MultiSelect
      label="Sites"
      options={sitesOptions}
      onUpdate={onUpdate}
      onClear={onClear}
      selected={selected}
      isLoading={isLoading}
      fullWidth={fullWidth}
      labelPosition={labelPosition}
    />
  );
}

export { SchedulingSiteFilter };
